/*
 ------------------------------------------------------------------
|  Copyright (c) 2015 Izenda, Inc.                                 |
|  ALL RIGHTS RESERVED                                             |
|                                                                  |
|  The entire contents of this file is protected by U.S. and       |
|  International Copyright Laws. Unauthorized reproduction,        |
|  reverse-engineering, and distribution of all or any portion of  |
|  the code contained in this file is strictly prohibited and may  |
|  result in severe civil and criminal penalties and will be       |
|  prosecuted to the maximum extent possible under the law.        |
|                                                                  |
|  RESTRICTIONS                                                    |
|                                                                  |
|  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES           |
|  ARE CONFIDENTIAL AND PROPRIETARY TRADE                          |
|  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS              |
|  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET    |
|  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.                 |
|                                                                  |
|  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED      |
|  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE        |
|  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE       |
|  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT  |
|  AND PERMISSION FROM IZENDA INC.                                 |
|                                                                  |
|  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON  |
|  ADDITIONAL RESTRICTIONS.                                        |
 ------------------------------------------------------------------
*/

/**
 * Security Render Html In Printing/Exporting Component
 */
!(function () {
  var React = require('react');
  var observer = require('mobx-react').observer;
  var Input = require('share/components/controls/Izenda.Input');
  var EventsUtils = require('EventUtils');

  var SecurityRenderHtmlInPrintingExporting = React.createClass({

    propTypes: {
      store: React.PropTypes.object.isRequired
    },

    renderRenderHtmlInPrintingExporting: function (bundle) {
      var notifyChange = EventsUtils.notifyChange;
      var model = this.props.store.model;

      return (
        <div className="form-group">
        <label className="col-md-7 col-xs-6 control-label field-name">
          <span>{bundle.LABEL.SECURITY_RENDER_HTML_EXPORT}</span>
        </label>
        <div className="col-md-5 col-xs-6 u_controlHeight">
          <Input
            type='checkbox'
            checked={model.renderhtmlexport}
            onChange={notifyChange(model.updateHtmlexport.bind(model), EventsUtils.CHECKBOX)}
          />
        </div>
      </div>
      )
    },

    render: function () {
      var store = this.props.store;
      var bundle = store.getBundle();

      return (
          <div className="form-horizontal">
            {this.renderRenderHtmlInPrintingExporting(bundle)}
          </div>
      )
    },
  });

  module.exports = observer(SecurityRenderHtmlInPrintingExporting);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/AdvancedSetting/Izenda.SecurityRenderHtmlInPrintingExporting.jsx